import { isEmpty, isNil } from 'lodash';

/** A location's subareas as the organization's insured properties carry them, keyed by subarea id. */
export type LocationSubareas = Record<string, unknown>;

/**
 * Whether a GL/WC incident shows its Sublocation field.
 *
 * Subareas are configured per location, so the field is offered wherever the location has some to
 * pick from. A claim that already records a subarea keeps the field even when its location lists
 * none, so the recorded subarea is not dropped without trace and can still be cleared. Its name is
 * looked up among that location's subareas only, so in that case the field shows no name.
 *
 * @param locationSubareas - the subareas of the location in question, if it has any
 * @param recordedSubareaId - the subarea the claim already records; omitted where nothing is recorded
 *   yet, as on an FNOL
 */
export const shouldShowSublocationField = (
  locationSubareas: LocationSubareas | null | undefined,
  recordedSubareaId?: number | null
): boolean => !isEmpty(locationSubareas) || !isNil(recordedSubareaId);
